import { useEffect, useMemo } from 'react'
import { getAllWallets } from '../../../reducks/resources/wallet/actions'

const { useSelector, useDispatch } = require('react-redux')

const useWalletContainer = () => {
  const dispatch = useDispatch()
  const { fetching, pagination, wallets, hasFilters } = useSelector(
    (store) => store.walletReducer
  )
  const profile = useSelector((state) => state.currentUserReducer.profile)

  const isEmpty = useMemo(
    () => !fetching && !wallets.length,
    [fetching, wallets]
  )

  const canLoadMore = !fetching && pagination.currentPage < pagination.lastPage

  const handlePaginate = () => {
    dispatch(getAllWallets())
  }

  useEffect(() => {
    if (!wallets.length) {
      dispatch(getAllWallets())
    }
  }, [])

  return {
    canLoadMore,
    fetching,
    handlePaginate,
    hasFilters,
    isEmpty,
    profile,
    total: pagination.total,
    wallets
  }
}

export default useWalletContainer
